import React, {useEffect, useState} from 'react';
import {motion} from "framer-motion";
import main_block_bg from "./images/main_page_bg.svg";
import Header from "../components/Header";
import left_top_banner_image from "./images/banner_image_left.png"
import {Link} from "react-scroll";
import right_top_banner_image from "./images/banner_right_image.png";
import "./architecturePage.css"
import core_essentials1 from "../ForIssuers/images/core_essentials1.svg";
import core_essentials2 from "../ForIssuers/images/core_essentials2.svg";
import core_essentials3 from "../ForIssuers/images/core_essentials3.svg";

import api_first_gal from "./images/api_first_gal.svg";
import api_first_image from "./images/api_first_image.png";
import works_icon1 from "../ForOrganizations/images/works_icon1.svg";
import works_icon2 from "../ForOrganizations/images/works_icon2.svg";
import works_icon3 from "../ForOrganizations/images/works_icon3.svg";
import works_icon4 from "../ForOrganizations/images/works_icon4.svg";
import continuty_block_image from "./images/continuty_block_image.png";
import mobile_continuty_block_image from "./images/mobile_continuty.png";
import gal_circle_green from "./images/gal_circle_green.svg";
import integration_image from "./images/integration_image.png";
import waves_bg from "../ForOrganizations/images/waves_bg.svg";
import request_info_img from "./images/request_info_img.svg";
import InputContainer from "../UnduraCore/components/InputContainer";
import inputNameIcon from "../UnduraCore/images/userNameIcon.svg";
import mail_icon from "../UnduraCore/images/mail_icon.svg";
import inputPencilIcon from "../UnduraCore/images/pencilIcon.svg";
import white_logo from "../UnduraCore/images/white_logo.svg";
import Footer from "../components/Footer";
import DevelopmentButton from "../components/DevelopmentButton";
import axios from "axios";
import warning_triangle from "../UnduraCore/images/warning_triangle.svg";
import CoreWarning from "../UnduraCore/components/CoreWarning";




const useImageLoad = (src) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = src;
        img.onload = () => setLoaded(true);
        img.onerror = () => setLoaded(true); // чтобы не зависло
    }, [src]);

    return loaded;
};


const ArchitecturePage = () => {
    const [contactEmail, setContactEmail] = useState("")
    const [contactFullName, setContactFullName] = useState("")
    const [contactMessage, setContactMessage] = useState("")
    const [subscribeValue, setSubscribeValue] = useState("")

    let sendApiContact = () => {
        axios.post("https://api.undura.com/api/v1/contact", {
            full_name: contactFullName,
            email: contactEmail,
            message: contactMessage,
            honeypot: ""
        }).then(r => console.log(r)).catch((er) => console.error(er))
    }
    let sendApiSubscribe = () => {
        axios.post("https://api.undura.com/api/v1/newsletter/subscribe", {
            email: subscribeValue,
            honeypot: ""
        }).then(r => console.log(r)).catch((er) => console.error(er))
    }

    useEffect(() => {
        if (window.location.hash) {
            const el = document.querySelector(window.location.hash);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });

                window.history.replaceState(null, "", window.location.pathname);
            }
        }
    }, []);

    const bgLoaded = useImageLoad(main_block_bg);
    const leftLoaded = useImageLoad(left_top_banner_image);
    const rightLoaded = useImageLoad(right_top_banner_image);

    const fadeUpItem = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };
    const hoverScale = { whileHover: { scale: 1.03 }, transition: { type: "spring", stiffness: 250 } };

    const sectionViewport = { initial: "hidden", whileInView: "visible", viewport: { once: true, amount: 0.3 } };


    const staggerContainer = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15
            }
        }
    };
    const pointVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" }
        })
    };
    const fadeNumeric = {
        initial: "hidden",
        whileInView: "visible",
        viewport: {once: true},
        variants: pointVariants
    };
    const fadeUp = {
        initial: {opacity: 0, y: 40},
        whileInView: {opacity: 1, y: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeDown = {
        initial: {opacity: 0, y: -40},
        whileInView: {opacity: 1, y: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeLeft = {
        initial: {opacity: 0, x: -50},
        whileInView: {opacity: 1, x: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeRight = {
        initial: {opacity: 0, x: 50},
        whileInView: {opacity: 1, x: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };

    const hoverButton = {
        whileHover: {
            scale: 1.05,
            transition: {type: "spring", stiffness: 300}
        }
    };

    const buttonAnimate = {
        initial: fadeUp.initial,
        whileInView: fadeUp.whileInView,
        viewport: fadeUp.viewport,
        transition: fadeUp.transition,
        whileHover: hoverButton.whileHover
    }


    const establishingPoints = [
        {
            name: "Governance & team structure",
            desc: "Core leadership roles (CEO, CCO/MLRO, CTO) and compliance-first governance."
        },
        {
            name: "Legal entity & back office",
            desc: "Company setup, basic processes, and partnerships with legal and accounting providers."
        },
        {
            name: "ECSPR authorization",
            desc: "Regulatory documentation, policies, and processes to operate as a supervised provider."
        },
        {
            name: "Risk & Compliance Core",
            desc: "Implementation of the core compliance workflows and monitoring logic."
        },
        {
            name: "Data Integrity Core",
            desc: "Identity, tenant isolation, and archival structures."
        },
        {
            name: "Continuity & Custody Core",
            desc: "Continuity & Custody Core\n" +
                "Resilience, backup servicer integration, and custody boundaries."
        },
    ]

    const blockVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };


    const staggerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, delay: i * 0.15, ease: "easeOut" }
        })
    };

    const [isFocusedTextarea, setIsFocusedTextarea] = useState(false);

    const focusedTextArea = `textarea_bg ${isFocusedTextarea ? 'focused_textarea' : ''}`;
    return (
        <div className="architecture_page">
            <CoreWarning/>
            <motion.img src={main_block_bg} alt="" className="main_block_bg" {...fadeUp}/>

            <Header mode="core"/>

            <div className="architecture_banners">
                <div className="left_banner_image_arch">
                    <img src={left_top_banner_image} alt=""/>
                </div>
                <div className="architecture_banners_text">
                    <motion.div className="sticky_disclaimer" {...fadeUp}>
                        <div className="circle"></div>
                        Regulated Infrastructure
                    </motion.div>

                    <motion.div className="main_text_banners" {...fadeLeft}>
                        Architecture built for regulation and resilience
                    </motion.div>

                    <motion.div className="for_issuers_banners_desc" {...fadeRight}>
                        Undura Core is designed as a modular, API-first infrastructure that supports regulated
                        crowdfunding and securities platforms under ECSPR and MiFID principles.
                        <br/>
                        <br/>
                        The architecture separates risk, data, and continuity concerns into dedicated cores, making the
                        system transparent, auditable, and ready for supervised environments.
                    </motion.div>

                    {/*<motion.div className="for_issuers_main_buttons">
                        <motion.a className="be_first_arch" href="#get-in-touch" {...buttonAnimate}
                                  custom={0} {...fadeNumeric}>
                            Be first
                        </motion.a>
                        <Link to="issuers_overview"
                              smooth={true}
                              duration={500}
                              offset={-200}
                              spy={true}>
                            <motion.div className="how_it_works_arch" {...buttonAnimate} custom={1} {...fadeNumeric}>
                                How it works
                            </motion.div>
                        </Link>
                    </motion.div>*/}
                    <motion.div className="for_issuers_main_buttons">
                        <motion.a className="be_first_arch" href="#get-in-touch" {...buttonAnimate}
                                  custom={0} {...fadeNumeric}>
                            Be first
                        </motion.a>
                        <a href="#three_core_section"
                              >
                            <motion.div className="how_it_works_arch" {...buttonAnimate} custom={1} {...fadeNumeric}>
                                How it works
                            </motion.div>
                        </a>
                    </motion.div>
                </div>
                <div className="right_banner_image_arch">
                    <img src={right_top_banner_image} alt=""/>
                </div>

            </div>
            <a name = "three_core_section"></a>
            <div className="three_core_section">

                <motion.div className="three_core_section_name" {...fadeLeft}>
                    Three core sectors, one unified <span>infrastructure</span>
                </motion.div>


                <motion.div className="three_core_section_desc" {...fadeRight}>
                    <div className="first_desc_arch">
                        At the heart of Undura Core are three main architectural sectors, each responsible for a
                        critical dimension of a regulated platform: compliance logic, data integrity, and operational
                        continuity. Together, they provide a foundation that can be applied to different business models
                        without compromising regulatory expectations.
                    </div>
                </motion.div>
            </div>
            <motion.div className="core_essentials_three_blocks">
                <motion.div className="core_essentials_block" {...fadeNumeric} custom={0}>
                    <div className="core_essentials_number">
                        <img src={core_essentials1} alt=""/>
                    </div>
                    <div className="core_essentials_name">Risk & Compliance Core</div>
                    <div className="core_essentials_desc">Onboarding logic, risk flags, and compliance workflows that
                        ensure issuers and investors operate within AML/CTF and ECSPR/MiFID-aligned standards.
                    </div>
                </motion.div>

                <motion.div className="core_essentials_block" {...fadeNumeric} custom={1}>
                    <div className="core_essentials_number"><img src={core_essentials2} alt=""/></div>
                    <div className="core_essentials_name">Data Integrity Core</div>
                    <div className="core_essentials_desc">Unified identity, tenant isolation, and long-term archival of
                        critical records — so every action can be traced, validated, and retained according to policy.
                    </div>
                </motion.div>

                <motion.div className="core_essentials_block" {...fadeNumeric} custom={2}>
                    <div className="core_essentials_number"><img src={core_essentials3} alt=""/></div>
                    <div className="core_essentials_name">Continuity & Custody Core</div>
                    <div className="core_essentials_desc">Resilience, backups, and controlled handover capabilities,
                        enabling a supervised backup operator to continue servicing investments if required by
                        regulators.
                    </div>
                </motion.div>
            </motion.div>
            <a href = "#get-in-touch" className = "three_core_section_a">
                <motion.div className="be_first" {...buttonAnimate}
                            {...fadeNumeric} custom={0}>Be first
                </motion.div>
            </a>

            <div className="api_first_full_width">
                <div className="api_first_block">
                    <motion.div className="api_first_info" {...fadeLeft}>
                        <div className="api_first_name">
                            API-first, modular by design
                        </div>
                        <div className="api_first_desc">
                            Undura Core is built around an API-first philosophy: every critical capability — onboarding,
                            data access, reporting, and snapshotting — is exposed through controlled interfaces rather
                            than hard-wired screens.
                        </div>
                        <div className="api_first_institutions">
                            This allows institutions to:
                        </div>
                        {["Embed Undura's logic into their own platforms", "Integrate with payment institutions and KYC providers", "Adapt the infrastructure to new instruments and markets without redesigning the entire system"]
                            .map((el, i) =>
                                <div className="api_first_point" key={i}>
                                    <img src={api_first_gal} alt=""/>
                                    {el}
                                </div>
                            )}

                    </motion.div>

                    <motion.div className="api_first_image" {...fadeRight}>
                        <img src={api_first_image} alt=""/>
                    </motion.div>
                </div>
            </div>

            <motion.div className="main_text_arch" {...fadeLeft}>
                Risk & <span>Compliance Core</span>
            </motion.div>

            <motion.div className="infrastructure_details" {...fadeRight}>
                The Risk & Compliance Core centralizes how issuers and investors are onboarded, evaluated, and monitored
                from a regulatory perspective.
            </motion.div>

            <motion.div className="risk_core_three_blocks">
                <motion.div className="core_essentials_block" {...fadeNumeric} custom={0}>
                    <div className="core_essentials_number">
                        <img src={core_essentials1} alt=""/>
                    </div>
                    <div className="core_essentials_name">Risk & Compliance Core</div>
                    <div className="core_essentials_desc">Onboarding logic, risk flags, and compliance workflows that
                        ensure issuers and investors operate within AML/CTF and ECSPR/MiFID-aligned standards.
                    </div>
                </motion.div>

                <motion.div className="core_essentials_block" {...fadeNumeric} custom={1}>
                    <div className="core_essentials_number"><img src={core_essentials2} alt=""/></div>
                    <div className="core_essentials_name">Data Integrity Core</div>
                    <div className="core_essentials_desc">Unified identity, tenant isolation, and long-term archival of
                        critical records — so every action can be traced, validated, and retained according to policy.
                    </div>
                </motion.div>

                <motion.div className="core_essentials_block" {...fadeNumeric} custom={2}>
                    <div className="core_essentials_number"><img src={core_essentials3} alt=""/></div>
                    <div className="core_essentials_name">Continuity & Custody Core</div>
                    <div className="core_essentials_desc">Resilience, backups, and controlled handover capabilities,
                        enabling a supervised backup operator to continue servicing investments if required by
                        regulators.
                    </div>
                </motion.div>
            </motion.div>

            <motion.div className="main_text_arch" {...fadeLeft}>
                Data Integrity Core
            </motion.div>

            <motion.div className="infrastructure_details data_core_desc" {...fadeRight}>
                The Data Integrity Core is responsible for identity, isolation, and long-term records, ensuring that
                every data point in the system can be trusted.
            </motion.div>

            <div
                className="about_platform_details"
            >
                {[works_icon1, works_icon2, works_icon3, works_icon4].map(
                    (icon, i) => (
                        <motion.div key={i} className="details_block" {...fadeNumeric} custom={i}>
                            <div className="icons_block">
                                <div className="details_icon">
                                    <img src={icon} alt=""/>
                                </div>
                                <div className="details_number">0{i + 1}</div>
                            </div>
                            <div className="details_text">
                                <div className="details_block_name">
                                    {[
                                        "Undura ID",
                                        "Tenant isolation",
                                        "Archive & audit trail",
                                        "Access governance",
                                    ][i]}
                                </div>
                                {
                                    [
                                        "A unified investor identity concept that can be used across compatible platforms, allowing reuse of verified profiles where permitted.",
                                        "Each B2B client operates within its own logical data sector, ensuring that their investors and projects remain segregated from others while still benefiting from shared infrastructure.",
                                        "Critical records, contracts, and event history are preserved in a long-term archive with versioning and integrity checks, supporting audits, disputes, and lifecycle reporting.",
                                        "Access is governed by role and responsibility, implementing least-privilege principles for internal teams, clients, and end users.",
                                    ][i]
                                }
                            </div>
                        </motion.div>
                    )
                )}
            </div>


            <div className="continuity_full_width">
                <div className="continuity_block">
                    <motion.div className="continuity_info" {...fadeLeft}>
                        <div className="continuity_name">
                            Continuity & Custody Core
                        </div>
                        <div className="continuity_desc">
                            The Continuity & Custody Core ensures that Undura-based platforms can withstand adverse
                            events and honour regulatory expectations around service continuity and client asset
                            protection.
                        </div>

                        <motion.div className="continuity_image mobile" {...fadeRight}>
                            <img src={mobile_continuty_block_image} alt=""/>
                        </motion.div>

                        {["Resilience and backups", "Backup operator integration", "Custody boundaries"]
                            .map((el, i) =>
                                <div className="continuity_point" key={i}>
                                    <div className="continuity_point_name">
                                        {el}
                                    </div>
                                    <div className="continuity_point_desc">
                                        {["Core state is regularly consolidated into controlled snapshots and backups, so the platform can be restored to a known-good state in case of disruption.",
                                            "Architecture anticipates cooperation with a designated backup servicer. Under supervision, this entity can receive structured system snapshots to continue servicing investments if Undura becomes unable to operate.",
                                            "The infrastructure is designed so that client funds flow through licensed payment institutions and escrow partners, not through Undura’s own balance sheet."][i]}
                                    </div>
                                </div>
                            )}

                    </motion.div>

                    <motion.div className="continuity_image desktop" {...fadeRight}>
                        <img src={continuty_block_image} alt=""/>
                    </motion.div>
                </div>
            </div>


            <div className="integration_block">
                <motion.div className="integration_info" {...fadeLeft}>
                    <div className="integration_block_name">
                        Integration with regulated partners
                    </div>
                    <div className="integration_block_desc">
                        Undura Core does not attempt to replace regulated financial institutions or KYC providers.
                        Instead, it orchestrates and standardizes how they interact with platforms.
                    </div>
                    <motion.div className="integration_image mobile" {...fadeRight}>
                        <img src={integration_image} alt=""/>
                    </motion.div>
                    <div className="integration_points">
                        {[
                            "KYC / KYB providers — used for identity and business verification.",
                            "EMI / payment institutions — handle custody and movement of funds.",
                            "White-label platforms & hubs — expose the infrastructure to end users through branded experiences."]
                            .map((el, i) =>
                                <div className="integration_point" key={i * Math.random()}>
                                    <img src={api_first_gal} alt=""/>
                                    {el}
                                </div>
                            )}
                    </div>
                    <div className="green_integration_info">
                        <img src={gal_circle_green} alt=""/>
                        Undura never holds client funds; it coordinates flows via licensed partners.
                    </div>

                </motion.div>
                <motion.div className="integration_image desktop" {...fadeRight}>
                    <img src={integration_image} alt=""/>
                </motion.div>
            </div>


            <div className="establishing_block">
                <motion.div className="establishing_main_info" {...fadeLeft}>
                    <motion.div className="sticky_disclaimer" {...fadeUp}>
                        <div className="circle"></div>
                        Phase 1
                    </motion.div>
                    <div className="establishing_name">
                        Establishing the Core architecture
                    </div>
                    <div className="establishing_desc">
                        The Data Integrity Core is responsible for identity, isolation, and long-term records, ensuring
                        that every data point in the system can be trusted.
                    </div>
                    <a href = "#get-in-touch">
                    <div className="be_first">
                        Be first
                    </div>
                    </a>
                </motion.div>

                <div className="establishing_blocks">
                    {establishingPoints.map(({name, desc}, idx) => <motion.div className="establishing_point" {...fadeUp}>
                        <div className="establishing_number_name">
                            <div className="establishing_number">
                                1.{idx}
                            </div>
                            <div className="establishing_point_name">
                                {name}
                            </div>
                        </div>
                        <div className="establishong_point_desc">
                            {desc}
                        </div>
                    </motion.div>)}

                    <motion.div className="establishing_point last" {...fadeUp} custom={Number(establishingPoints.length + 1)*0.5}>
                        Later phases will build on this foundation with additional modules (e.g., instrument engines,
                        reporting layers, and optional secondary-market capabilities).
                    </motion.div>

                </div>
            </div>

            <motion.div
                className="no_coding_block"
                {...fadeUp}
            >
                <motion.div className="no_coding_content architect">
                    <img src={waves_bg} alt="" className="waves_last"/>
                    <div className="no_coding_name">
                        Request a deeper architecture brief
                    </div>
                    <div className="no_coding_text architect">This page provides a high-level view of the Undura Core
                        architecture. For partners, regulators, or technical teams that require more detail, we can
                        provide a structured architecture brief under NDA.
                    </div>

                    <div className="request_info_block">
                        <img src={request_info_img} alt=""/>
                        We do not publicly disclose low-level implementation details, specific technologies, or internal
                        interfaces.
                    </div>
                    <DevelopmentButton
                        className="start_now_button_last pos_center_popup"
                    >
                        Request architecture brief
                    </DevelopmentButton>
                </motion.div>
            </motion.div>


            <a name = "get-in-touch"></a>
            <motion.div className="get_in_touch_full_block" {...sectionViewport} variants={staggerContainer}>
                <motion.div className="get_in_touch_block" variants={staggerContainer}>
                    <motion.div className="get_in_touch_message_block" variants={fadeUpItem}>
                        <motion.div className="get_in_touch_name" variants={fadeUpItem}>
                            Get in Touch
                        </motion.div>
                        <form className="get_in_touch_form">
                            <div className="input_name">Full Name<span>*</span></div>
                            <motion.div variants={fadeUpItem}>
                                <InputContainer inputPlaceholder="James Brown" inputIcon={inputNameIcon} inputType="text" value={contactFullName} onChange={(e) => {
                                    setContactFullName(e.target.value)
                                }}/>
                            </motion.div>

                            <div className="input_name">E-mail<span>*</span></div>
                            <motion.div variants={fadeUpItem}>
                                <InputContainer inputPlaceholder="hello@undura.com" inputIcon={mail_icon} inputType="text" value={contactEmail} onChange={(e) => {
                                    setContactEmail(e.target.value)
                                }}/>
                            </motion.div>

                            <div className="input_name">Your message<span>*</span></div>
                            <div className="textarea_container">
                                <motion.div className={focusedTextArea} variants={fadeUpItem}>
                                    <img src={inputPencilIcon} alt=""/>
                                    Type here
                                </motion.div>
                                <textarea className="type_here_textarea" onFocus={() => {
                                    setIsFocusedTextarea(true)
                                }} onBlur={(e) => {
                                    if (e.target.value.length === 0) {
                                        setIsFocusedTextarea(false)
                                    }
                                }} value={contactMessage} onChange={(e) => {
                                    setContactMessage(e.target.value)
                                }}/>
                            </div>
                            <motion.button className="get_in_touch_form_submit" type="submit"
                                           onClick={(e) => {
                                               e.preventDefault()
                                               sendApiContact()
                                           }} variants={fadeUpItem} {...hoverScale}>
                                Submit Inquiry
                            </motion.button>
                        </form>
                    </motion.div>

                    <motion.div className="about_undura_get_in_touch" variants={fadeUpItem}>
                        <img src={white_logo} alt=""/>

                        <div className="about_undura_get_in_touch_main_text">
                            Reach out to discuss partnership opportunities, platform integration,
                            or other collaboration formats within the Undura ecosystem.
                        </div>
                        <div className="about_undura_get_in_touch_desc">
                            Messages are handled directly by the Core team.
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>

            <Footer/>
        </div>
    );
};

export default ArchitecturePage;